import React from "react";

const MAP = {
  Red: { bg: "bg-[#fdecea]", text: "text-[#a71d1d]", dot: "bg-[#c62828]", ring: "ring-[#f3bcb8]" },
  Amber: { bg: "bg-[#fff6e0]", text: "text-[#8a6100]", dot: "bg-[#e6a100]", ring: "ring-[#f0dca6]" },
  Green: { bg: "bg-[#e8f6ee]", text: "text-[#17643a]", dot: "bg-[#1f8a4c]", ring: "ring-[#b6dfc6]" },
};

export const RagBadge = ({ value = "Green", label, testId }) => {
  const s = MAP[value] || MAP.Green;
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-semibold ring-1 ${s.bg} ${s.text} ${s.ring}`}
    >
      <span className={`h-2 w-2 rounded-full ${s.dot}`} />
      {label || value}
    </span>
  );
};

export const RAG_OPTIONS = ["Green", "Amber", "Red"];
